import { p as proxyCustomElement, H, h } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';

const cosmosLinkCss = "@keyframes cosmos-link-dim-border{0%{text-decoration-color:transparent}100%{text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{animation:none;border-color:currentColor;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){animation:1s cosmos-link-dim-border steps(2, start) infinite paused}";

const generateClassNames = bem('cosmos-link');
const CosmosLink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Use this to change the visual appearance of the link.
         */
        this.kind = 'underlined';
        this.handleKeyDown = (event) => {
            if (this.href)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.target.click();
            }
        };
    }
    render() {
        const Tag = this.href ? 'a' : 'span';
        const role = Tag === 'span' ? 'button' : undefined;
        return (h(Tag, { key: 'd25a9b10e4cf634c55666dd4585d45fa8f2aae68', class: generateClassNames({
                kind: this.kind,
            }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: role, tabIndex: 0, target: this.target }, h("slot", { key: '5aaa04610fc9574bb27c360f869b856568f1ea87' })));
    }
    static get style() { return cosmosLinkCss; }
}, [1, "cosmos-link", {
        "href": [513],
        "kind": [513],
        "rel": [513],
        "target": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-link"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosLink$1);
            }
            break;
    } });
}

const CosmosLink = CosmosLink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosLink, defineCustomElement };
